"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

function convertableSchemaToSchema(oldSchemaType, newSchemaType) {
  if (oldSchemaType === newSchemaType) {
    return true;
  }
  if ([oldSchemaType, newSchemaType].includes("object") || [oldSchemaType, newSchemaType].includes("array")) {
    return false;
  }
  return true;
}

export { convertableSchemaToSchema };
